import * as stylex from '@stylexjs/stylex';
import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router';
import { Group } from 'react-aria-components';

import { ErrorState } from '@/components/error-state.component';
import { Logo } from '@/components/logo.component';
import { NotFoundState } from '@/components/not-found-state.component';
import { HORIZONTAL_NAVIGATION_SLOTS, HorizontalNavigation } from '@/libs/serenity-ui';
import { $ } from '@/libs/serenity-ui/tokens.stylex';

export const Route = createFileRoute('/_minimal')({
  component: RouteComponent,
  notFoundComponent: NotFoundState,
  errorComponent: ErrorState,
  head: () => ({
    meta: [
      {
        name: 'theme-color',
        media: '(prefers-color-scheme: light)',
        content: '#F8F8FB',
      },
      {
        name: 'theme-color',
        media: '(prefers-color-scheme: dark)',
        content: '#1D1D1E',
      },
    ],
    styles: [
      {
        children: `
          html, body {
            background-color: ${$.surfaceBGSecondary};
          }
          #app {
            display: flex;
            flex-direction: column;
          }
        `,
      },
    ],
  }),
});

function RouteComponent() {
  const matches = useMatches();

  const childMatch = matches.at(-1);
  const staticData = childMatch?.staticData?.minimal;
  return (
    <>
      <header {...stylex.props(styles.header)}>
        <HorizontalNavigation>
          {(staticData?.showLogo ?? false) &&
          <Group slot={HORIZONTAL_NAVIGATION_SLOTS.CENTER}>
            <Logo />
          </Group>}
        </HorizontalNavigation>
      </header>
      <main {...stylex.props(styles.main)}>
        <Outlet />
      </main>
    </>
  );
}

const styles = stylex.create({
  header: {
    backgroundColor: $.surfaceBGSecondary,
    width: '100%',
  },
  main: {
    alignItems: 'center',
    backgroundColor: $.surfaceBGSecondary,
    display: 'flex',
    flexBasis: 1,
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    justifyContent: 'center',
    width: '100%',
  },
});
